import React from 'react';
import { Button, Flex, Grid } from 'antd';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ExpertsList from './ExpertsList';

const { useBreakpoint } = Grid;

const HomeExperts = function () {
  const { search } = useLocation();
  const { xs } = useBreakpoint();
  const { partnerId } = useParams();
  const { t } = useTranslation();

  return (
    <>
      <ExpertsList
        first={xs ? 3 : 4}
        url={`/${partnerId}/guurus/`}
      />
      <Flex justify="center">
        <Link tabIndex={-1} to={`/${partnerId}/guurus${search}`}>
          <Button type="primary" size="large" shape="round">
            {t('chat:::communityMembersButton')}
          </Button>
        </Link>
      </Flex>
    </>
  );
};

export default HomeExperts;
